import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import "./core/firebase/index";
import "./sw-client";

// Import Mixpanel SDK
import mixpanel from "mixpanel-browser";
 
// Initialize Mixpanel
mixpanel.init(process.env.REACT_APP_MIXPANEL, {
  debug: process.env.NODE_ENV === 'development',
  track_pageview: true,
  persistence: "localStorage",
});

// Render the app
ReactDOM.render(
  <App />,
  document.getElementById("root")
);
